import { normalizeChartingFinderDefinition, normalizeChartingFinderOptions } from '@/features/charting-next/adapters/chartingFinderAdapters';
import { normalizeChartingMutationResult } from '@/features/charting-next/adapters/chartingPreferenceAdapters';
import { buildChartingLastSearchPayload } from '@/features/charting-next/adapters/chartingPayloads';
import { get, postForm } from '@/features/charting-next/api/chartingRepositoryClient';

const loadFinderDefinitionPayload = async (finderName = '') => {
    const normalizedFinderName = String(finderName || '').trim();

    if (!normalizedFinderName) {
        return get('/api/v1/stock-finder/default-finder');
    }

    return get(`/api/v1/stock-finder/finder/${encodeURIComponent(normalizedFinderName)}`);
};

export async function fetchChartingFinderDefinition({ finderName = '' } = {}) {
    const [defaultFinder, preferences, currencies, countries, sectors, industries] = await Promise.allSettled([
        loadFinderDefinitionPayload(finderName),
        get('/api/v1/stock-finder/preferences'),
        get('/api/v1/stock-finder/available-currencies'),
        get('/api/v1/stock-finder/available-countries'),
        get('/api/v1/stock-finder/available-sectors'),
        get('/api/v1/stock-finder/available-industries')
    ]);

    return normalizeChartingFinderDefinition({
        defaultFinder: defaultFinder.status === 'fulfilled' ? defaultFinder.value : null,
        preferences: preferences.status === 'fulfilled' ? preferences.value : [],
        availableCurrencies: currencies.status === 'fulfilled' ? normalizeChartingFinderOptions(currencies.value) : [],
        availableCountries: countries.status === 'fulfilled' ? normalizeChartingFinderOptions(countries.value) : [],
        availableSectors: sectors.status === 'fulfilled' ? normalizeChartingFinderOptions(sectors.value) : [],
        availableIndustries: industries.status === 'fulfilled' ? normalizeChartingFinderOptions(industries.value) : []
    });
}

export async function updateChartingLastSearch(filters = {}, options = {}) {
    const payload = await postForm('/api/v1/stock-finder/update-last-search', buildChartingLastSearchPayload({ filters, baseFinder: options?.baseFinder || {} }));

    return normalizeChartingMutationResult(payload, 'La busqueda actual se ha actualizado.');
}

export async function deleteChartingLastSearch() {
    const payload = await get('/api/v1/stock-finder/delete-last-search');

    return normalizeChartingMutationResult(payload, 'La busqueda actual se ha reiniciado.');
}
